import React from "react";

function ParagraphItem({  body }) {
	return (
		<p className="custom-container-paragraph">{body}</p>
	);
}

export default ParagraphItem;
